const { logger } = require('@fiverr-private/obs');
const { DEFAULT_LOCALE } = require('../constants');
const { generateFormData } = require('./formData');

const translate = (k, locale = DEFAULT_LOCALE) => {
    try {
        return i18n.t(k, { $scope: locale });
    }
    catch (err) {
        logger.error(`Failed to get default value for key ${k}`);
        return false;
    }
};

const generateId = () => `_${Math.random().toString(36).substr(2, 9)}`;

module.exports = {
    translate,
    generateId,
    generateFormData
};
